import request from './index'
import {
  TeamInfo,
  TeamMemberInfo,
  CreateTeamRequest,
  JoinTeamRequest,
  UpdateChatModeRequest,
  UpdateTeamAiConfigRequest,
} from '../types'

export const teamApi = {
  createTeam: (data: CreateTeamRequest) =>
    request.post<TeamInfo>('/team/create', data),

  joinTeam: (data: JoinTeamRequest) =>
    request.post<TeamInfo>('/team/join', data),

  getMyTeams: () =>
    request.get<Array<TeamInfo>>('/team/my'),

  getTeamDetail: (id: number) =>
    request.get<TeamInfo>(`/team/${id}`),

  getTeamMembers: (id: number) =>
    request.get<Array<TeamMemberInfo>>(`/team/${id}/members`),

  updateChatMode: (id: number, data: UpdateChatModeRequest) =>
    request.put<TeamInfo>(`/team/${id}/chat-mode`, data),

  updateAiConfig: (id: number, data: UpdateTeamAiConfigRequest) =>
    request.put<TeamInfo>(`/team/${id}/ai-config`, data),

  removeMember: (teamId: number, memberId: number) =>
    request.delete<void>(`/team/${teamId}/member/${memberId}`),

  disbandTeam: (id: number) =>
    request.delete<void>(`/team/${id}`),
}
